import React from 'react';
import PropTypes from 'prop-types';

const AnimatedArrowDown = ({ expand }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.114"
      height="33.093"
      viewBox="0 0 21.114 33.093"
      style={{
        transition: 'transform 200ms ease-in-out',
        transform: expand ? 'translate3d(0, -3.5px, 0)' : 'translate3d(0, 0, 0)'
      }}
    >
      <g
        id="Group_1202"
        data-name="Group 1202"
        transform={expand ? 'translate(-477.387 -1013)' : 'translate(-477.387 -1020)'}
        style={{ transition: 'transform 200ms ease-in-out' }}
      >
        <line
          id="Line_82"
          data-name="Line 82"
          y2="29.48"
          transform="translate(487.944 1014.5)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="3"
        />
        <line
          id="Line_83"
          data-name="Line 83"
          x2="8.444"
          y2="7.037"
          transform="translate(479.5 1036.943)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="3"
        />
        <line
          id="Line_84"
          data-name="Line 84"
          x1="8.444"
          y2="7.037"
          transform="translate(487.944 1036.943)"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeWidth="3"
        />
      </g>
    </svg>
  );
};

AnimatedArrowDown.propTypes = {
  expand: PropTypes.bool
};

export default AnimatedArrowDown;
